import { useEffect, useState } from "react";

export function useNetworkStatus(): { online: boolean } {
	const [online, setOnline] = useState(() =>
		typeof window !== "undefined" ? navigator.onLine : true,
	);

	useEffect(() => {
		if (typeof window === "undefined") return;

		const goOnline = () => setOnline(true);
		const goOffline = () => setOnline(false);

		window.addEventListener("online", goOnline);
		window.addEventListener("offline", goOffline);

		return () => {
			window.removeEventListener("online", goOnline);
			window.removeEventListener("offline", goOffline);
		};
	}, []);

	return { online };
}
